import { Injectable } from '@angular/core';
import { AppSettings } from '../../proyect.conf';
import { HttpClient } from '@angular/common/http';
import { AutenticacionService } from './autenticacion.service';
import { map } from 'rxjs/operators';
import { ProductoDestino } from '../_models/producto-destino';
import {ProductoPoliticaAlerta} from '../_models/producto-politica-alerta';

@Injectable({
  providedIn: 'root'
})
export class ProductoPoliticaAlertaService {
  private rutServicio = AppSettings.rutServiciosAPL + '/api/productosPoliticasAlertas';

  constructor( private httClient: HttpClient, private autServicio: AutenticacionService ) {
  }

  listado() {
    return this.httClient.get( this.rutServicio ).pipe( map( res => res as ProductoPoliticaAlerta[] ) );
  }

  listadoHabilitados() {
    return this.httClient.get( this.rutServicio + '/enabled' ).pipe( map( res => res as ProductoPoliticaAlerta[] ) );
  }

  listadoPorProducto( idProducto: string ) {
    return this.httClient.get( this.rutServicio + '/producto/' + idProducto ).pipe( map( res => res as ProductoPoliticaAlerta[] ) );
  }

  listadoPorPolitica( idProducto: string ) {
    return this.httClient.get( this.rutServicio + '/politica/' + idProducto ).pipe( map( res => res as ProductoPoliticaAlerta[] ) );
  }

  obtenerPorId( id: string ) {
    return this.httClient.get( this.rutServicio + '/' + id ).pipe( map( res => res as ProductoPoliticaAlerta ) );
  }

  crear( regCrear: ProductoPoliticaAlerta ) {
    regCrear.auditoriaUsuario = this.autServicio.obtenerIdUsuarioLogueado();
    return this.httClient.post( this.rutServicio, regCrear ).pipe( map( res => res as ProductoPoliticaAlerta ) );
  }

  actualizar( regActualizar: ProductoPoliticaAlerta ) {
    regActualizar.auditoriaUsuario = this.autServicio.obtenerIdUsuarioLogueado();
    return this.httClient.put( this.rutServicio, regActualizar ).pipe( map( res => res as any ) );
  }

  bulk( regActualizar: ProductoPoliticaAlerta[] ) {
    regActualizar.map( ( s: ProductoPoliticaAlerta ) => {
      s.auditoriaUsuario = this.autServicio.obtenerIdUsuarioLogueado();
    } );
    return this.httClient.post( this.rutServicio + '/bulk', regActualizar  ).pipe( map( res => res as any ) );
  }
}
